import { render, staticRenderFns } from "./BlueFooter.vue?vue&type=template&id=2f8d9a7d&scoped=true&"
import script from "./BlueFooter.vue?vue&type=script&lang=js&"
export * from "./BlueFooter.vue?vue&type=script&lang=js&"
import style0 from "./BlueFooter.vue?vue&type=style&index=0&id=2f8d9a7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d9a7d",
  null
  
)

export default component.exports